import React from "react";
import homeStyles from "./Home.module.scss";
// Global Styles, imported only once, folder not under css modules, so styles can be used in any file
// import globalStyles from "../../styles/globalStyles.scss";
import Routes from "../../routing/Routes";
// import HomePage from "../HomePage/HomePage";

// const client = contentful.createClient({
//     // This is the space ID. A space is like a project folder in Contentful terms
//     space: "developer_bookshelf",
//     // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
//     accessToken: "0b7f6x59a0"
// });

// // This API call will request an entry with the specified ID from the space defined at the top, using a space-specific access token.
// client
//     .getEntry("5PeGS2SoZGSa4GuiQsigQu")
//     .then(entry => console.log(entry))
//     .catch(err => console.log(err));

// var contentfulClient = contentful.createClient({
//     accessToken: '0e3ec801b5af550c8a1257e8623b1c77ac9b3d8fcfc1b2b7494e3cb77878f92a',
//     space: 'wl1z0pal05vy'
// })

// var PRODUCT_CONTENT_TYPE_ID = '2PqfXUJwE8qSYKuM0U6w8M';

// // var container = document.getElementById('content');

// contentfulClient.getEntries({
//     content_type: PRODUCT_CONTENT_TYPE_ID
// })
//     .then((entries) => {
//         console.log("entries");
//         console.log(entries);
//         console.log(entries.items);
//         // container.innerHTML = renderProducts(entries.items)
//     })

class Home extends React.Component {
    render() {
        return (
            <div className={[homeStyles.container, "main-container"].join(" ")}>
                <div className={homeStyles.mainStyle}>
                    <Routes />
                </div>
            </div>
        );
    }
}

export default Home;
